export default {
    //时间格式化
    orderList : [
        {
            name :'火车票',
            href : 'home'
        },
        {
            name :'订单列表',
            href : 'orderList'
        },
    ],
    orderDetail : [
        {
            name :'火车票',
            href : 'home'
        },
        {
            name :'订单列表',
            href : 'orderList'
        },
        {
            name : '订单详情',
            href : 'orderDetail'
        }
    ],
    orderRefund : [
        {
            name :'火车票',
            href : 'home'
        },
        {
            name :'订单列表',
            href : 'orderList'
        },
        {
            name : '退票',
            href : 'orderRefund'
        }
    ],
    endorsed : [
        {
            name :'火车票',
            href : 'home'
        },
        {
            name :'订单列表',
            href : 'orderList'
        },
        {
            name : '改签',
            href : 'endorsed'
        }
    ],
    amountList : [
        {
            name :'火车票',
            href : 'home'
        },
        {
            name :'资金流水',
            href : 'amountList'
        }
    ],
    billList : [
        {
            name :'火车票',
            href : 'home'
        },
        {
            name :'帐单汇总',
            href : 'billList'
        },
    ],
    rechargeDetail : [
        {
            name :'火车票',
            href : 'home'
        },
        {
            name :'充值记录',
            href : 'rechargeDetail'
        },
    ],
    passenger : [
        {
            name :'火车票',
            href : 'home'
        },
        {
            name :'乘客列表',
            href : 'passenger'
        },
    ],
    platform : [
        {
            name :'火车票',
            href : 'home'
        },
        {
            name :'火车票网管',
            href : 'platform'
        },
    ],
    robDetail : [
        {
            name :'火车票',
            href : 'home'
        },
        {
            name :'订单列表',
            href : 'orderList'
        },
        {
            name :'抢票单详情',
            href : 'robDetail'
        },
    ],




}
